export default __webpack_public_path__ + "static/media/file-upload-fill.e9ece836.svg";